import AddressForm from 'components/Address/AddressForm/AddressForm';
import ErrorScrolling from 'components/Forms/utilities/ErrorScrolling';
import { manualAddressErrorOrder as errorOrder } from 'components/Address/util';
import { minLength } from 'utils/validation';

const AddressRegistrationForm = ({ onSubmit, ...props }) =>
  ErrorScrolling({
    ...props,
    datatag: 'address-registration-form',
    submitText: 'Next',
    submitResult: onSubmit,
    errorOrder,
    extraValidations: {
      firstNameExtraValidation: { validate: { minLength: minLength(2) } },
      lastNameExtraValidation: { validate: { minLength: minLength(2) } },
    },
  })(AddressForm);

export default AddressRegistrationForm;
